module.exports = __webpack_public_path__ + "cf3a871a2f393a50ff806c97712ef785.otf";